import { useState, useEffect } from "react";
import { httprequest } from "../../data/api";
import useValidator from "../../hooks/useValidator";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import { toast } from "react-toastify";
import InputGroup from "../../components/FormComponent/InputGroup";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import { Grid } from "@mui/material";

const ROLES_ENDPOINT = "api/v1/roles";
const INVITE_EMPLOYEE_SIGNUP = "api/v1/employees/invite";

const employeemodal = ({ isOpen, onClose, onSuccess }) => {
  const [employeeValidator, showValidationMessage] = useValidator();
  const [rolesData, setRolesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inviteForm, setInviteForm] = useState({
    email: "",
    role: "",
    job_title: ""
    // org_id: userRole?.org_id
  });

  /**
 * Handles input changes in the invite form.
 * Updates form state with the changed field.
 *
 * @function handleCreateChange
 * @param {SyntheticEvent} e - The input change event.
 */
  const handleCreateChange = (e) => {
    const { name, value } = e.target;
    setInviteForm({ ...inviteForm, [name]: value });
  };

  /**
 * Fetches available roles from the server and filters out restricted roles
 * such as "school_admin", "guardian", and "student".
 *
 * @function getRoles
 */
  const getRoles = () => {
    httprequest.get(`${ROLES_ENDPOINT}`).then((res) => {
      const updatedEmployee = res?.data?.data?.filter((newrole) => newrole?.role_type !== "school_admin" && newrole?.role_type !== "guardian" && newrole?.role_type !== "student");
      setRolesData(updatedEmployee);
    }).catch(() => {

    });
  };

  /**
 * Sends an invite to create a new employee account.
 * Validates the form before making the API call.
 *
 * @function handleCreateEmployee
 */
  const handleCreateEmployee = () => {
    if (employeeValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(INVITE_EMPLOYEE_SIGNUP, { recipients: [inviteForm] }).then((res) => {
        setIsLoading(false);
        const toastId = toast.success(res?.data?.message, {
          autoClose: 3000
        });

        setTimeout(() => {
          toast.dismiss(toastId);
          if (onSuccess) onSuccess();
          // window.location.reload();
        }, 3000);
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showValidationMessage(true);
    }
  };

  /**
 * Destructures employee invitation form data from the inviteForm state.
 *
 * @constant
 * @type {string}
 * @property {string} job_title - The job title input for the invite.
 * @property {string} email - The email address for the employee invite.
 * @property {string} role - The selected role for the invitee.
 */
  const { job_title, email, role } = inviteForm;

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div>
      <Modal
        title="Create Employee"
        subtitle={
          <div>Add this Employee into your school, on create, they will receive an email to create their password.
          </div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Job Title"
                  margin="normal"
                  inputType="text"
                  inputName="job_title"
                  inputValue={job_title}
                  onChange={handleCreateChange}
                  required
                />
                {employeeValidator.message("job_title", job_title, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <InputGroup
                  label="Email Address"
                  margin="normal"
                  inputType="email"
                  inputName="email"
                  inputValue={email}
                  onChange={handleCreateChange}
                  required
                />
                {employeeValidator.message("email", email, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <SelectGroup label="Role" required children={
                  <select onChange={handleCreateChange} value={role} name="role">
                    <option value="">--- Select ---</option>
                    {rolesData?.map((role) => {
                      return (
                        <option key={role?.role} value={role?.role_id}>{role?.role_name}</option>
                      );
                    })}
                  </select>
                }
                />
                {employeeValidator.message("role", role, "required")}
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button variant="primary" buttonName="Create Employee" buttonSize="full" color="btndefault" onClick={handleCreateEmployee} isLoading={isLoading} />
          </>
        }
        isopen={isOpen}
        closeModal={onClose}
      />
    </div>
  );
};

export default employeemodal;
